{
  "phone-number-input": {
    "text": {
      "country-code": "Code pays",
      "country-code-invalid": "Non valide",
      "country-code-required": "Obligatoire",
      "phone-nr": "Numéro de téléphone",
      "phone-nr-invalid": "Le numéro de téléphone mobile n'est pas valide",
      "phone-nr-required": "Le numéro de téléphone portable est requis"
    }
  }
}
